import PropTypes from 'prop-types';
import { MasterCategoryTab } from './MasterCategoryTab';
import { sCategoriesOf, addSCategory, updateSCategory, deleteSCategory } from '../../data/store';
import { useSharedStore } from '../../hooks/useSharedStore';
export const SCategoryTab = ({ org, showNotification }) => {
  useSharedStore();
  return (
    <MasterCategoryTab
      org={org}
      title="S-Categories"
      singular="S-Category"
      list={() => sCategoriesOf(org.id)}
      onCreate={addSCategory}
      onUpdate={updateSCategory}
      onDelete={deleteSCategory}
      showNotification={showNotification}
    />
  );
};

SCategoryTab.propTypes = {
  org: PropTypes.object.isRequired,
  showNotification: PropTypes.func,
};
